// Barrel export for chart components
export { default as StatusChartView } from '../../../shared/components/charts/StatusChartView/StatusChartView';

// Export types
export type { statusChartViewProps } from '../../../shared/components/charts/StatusChartView/StatusChartViewProps';